"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = isShootstaOrgId;
var SHOOTSTA_ORG_ID = "f4e7f2c7-7911-4ca9-84f0-4b3ca37249bd";

function isShootstaOrgId(a) {
  return SHOOTSTA_ORG_ID === a;
}